import { useAtom } from "jotai";
import { backendDataAtom } from "atoms/backendDataAtom.js";
import { backendGet, backendPost } from "@accredo/fe-shared/services/dataService.js";
import { useSnackbar } from "notistack";
import { updateListItemState } from "./listStateHelpers.js";
import { handleDownload } from "components/MDDForm/helper.js";

export function usePaymentImportActions() {
  const [backendData, setBackendData] = useAtom(backendDataAtom);
  const { enqueueSnackbar } = useSnackbar();

  const state =
    backendData?.type === "payment_imports"
      ? backendData
      : { data: [], meta: {} };

  const setState = (data) => {
    setBackendData({
      type: "payment_imports",
      data: data,
    });
  };

  const createPaymentImport = async (form_data, options) => {
    form_data.api_version = "v2";

    const {
      label = "Zahlungimport erstellen",
      setIsLoading = () => {},
      setResult = () => {},
    } = options || {};

    await backendPost("data/payment-imports/upload", {
      label,
      toSend: form_data,
      enqueueSnackbar,
      setIsLoading,
      setResult: (res) => {
        updateListItemState(backendData, setBackendData, res.data);
        setResult(res);
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const getSimulationAvailability = async () => {
    const res = await backendGet("data/payment-imports/simulate/availability", {
      label: "Import-Simulation",
    });
    return res?.can_simulate === true;
  };

  const simulatePaymentImport = async (payload) => {
    return backendPost("data/payment-imports/simulate", {
      label: "Import simulieren",
      toSend: payload,
      enqueueSnackbar,
      setResult: (res) => {
        if (res?.content_base64 && res?.filename) {
          handleDownload({
            filename: res.filename,
            filedata: res.content_base64,
          });
        }
      },
    });
  };

  return {
    createPaymentImport,
    getSimulationAvailability,
    simulatePaymentImport,
    setState,
    state,
  };
}
